module.exports = __webpack_public_path__ + "img/emoji_53.ed99b1a0.png";